var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var RemoteTransfer = function RemoteTransfer(values) {
  "use strict";

  _classCallCheck(this, RemoteTransfer);

  Object.assign(this, values);
  this.expires_at = new Date(this.expires_at);
};

module.exports = RemoteTransfer;